import { createSelector } from 'reselect';

import getCities from '@core/reducers/cities/selectors/getCities';
import { SEARCH_FORM } from '@location/model';
import { SEARCH_FORM_KEY } from '@location/constants';
import getPropFromModule from './getPropFromModule';

const { CITY_ID } = SEARCH_FORM_KEY;

const getSelectedCity = createSelector(
  getCities,
  state => getPropFromModule(state, SEARCH_FORM, CITY_ID),
  (cities, cityId) =>
    cityId && cities ? cities.find(c => c.id === cityId) : null,
);

export default getSelectedCity;
